import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e28f8aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"mediaclText\" data-v-e28f8aec><div class=\"left\" data-v-e28f8aec><div class=\"sex\" data-v-e28f8aec>药物治疗方案</div><div class=\"age\" data-v-e28f8aec>女，17岁</div></div></div><div class=\"bottom\" data-v-e28f8aec></div>", 2)
const _hoisted_7 = { class: "boxTail" }
const _hoisted_8 = { class: "leftright" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "给予辅舒良，枸地氯雷他定，生理性海盐水治疗")
  ])
], -1))
const _hoisted_10 = { class: "btnBox" }
const _hoisted_11 = { class: "ip" }
const _hoisted_12 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_question3 = _resolveComponent("question3")!
  const _component_correct = _resolveComponent("correct")!
  const _component_reason = _resolveComponent("reason")!
  const _component_jiexiao = _resolveComponent("jiexiao")!
  const _component_sikao = _resolveComponent("sikao")!
  const _component_sikaoone = _resolveComponent("sikaoone")!
  const _component_sikaothree = _resolveComponent("sikaothree")!
  const _component_sikaotwo = _resolveComponent("sikaotwo")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".64rem",
                height: ".6133rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_9
          ])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "5.64rem",
            height: "1.3333rem",
            src: require('../assets/jxbtn.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event)),
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'question3')
              ? (_openBlock(), _createBlock(_component_question3, {
                  key: 1,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 2,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 3,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'jiexiao')
              ? (_openBlock(), _createBlock(_component_jiexiao, {
                  key: 4,
                  onOnChanged: $options.jiexiaoChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'sikao')
              ? (_openBlock(), _createBlock(_component_sikao, {
                  key: 5,
                  onOnChanged: $options.onSiKaoone,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'sikaoone')
              ? (_openBlock(), _createBlock(_component_sikaoone, {
                  key: 6,
                  onOnChanged: $options.onSiKaotwo,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'sikaothree')
              ? (_openBlock(), _createBlock(_component_sikaothree, {
                  key: 7,
                  onOnChanged: $options.onSiKaowenti,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'sikaotwo')
              ? (_openBlock(), _createBlock(_component_sikaotwo, {
                  key: 8,
                  onOnChanged: $options.onSiKaowenti,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}